<template>
  <div class="home-page">
    <div class="sidebar-section" :class="{ 'sidebar-hidden': isSidebarCollapsed }">
      <sidebar @sidebar-toggle="handleSidebarToggle" @new-chat="handleNewChat" />
    </div>
    <div class="content-section" :class="{ 'content-full-width': isSidebarCollapsed }" :style="contentStyle">
      <main-content ref="mainContent" />
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/sidebar/Sidebar.vue';
import MainContent from '@/components/home/MainContent.vue';
import { checkAuth } from '@/utils/auth.js';

export default {
  name: 'HomePage',
  components: {
    Sidebar: Sidebar,
    MainContent
  },
  data() {
    return {
      isSidebarCollapsed: false,
      sidebarWidth: 318 // 侧边栏展开时的宽度
    };
  },
  computed: {
    contentStyle() {
      if (this.isSidebarCollapsed) {
        return {
          marginLeft: '0px',
          width: '100%',
          transition: 'margin-left 0.3s, width 0.3s'
        };
      } else {
        return {
          marginLeft: `${this.sidebarWidth}px`,
          width: `calc(100% - ${this.sidebarWidth}px)`,
          transition: 'margin-left 0.3s, width 0.3s'
        };
      }
    }
  },
  methods: {
    handleSidebarToggle(collapsed) {
      this.isSidebarCollapsed = collapsed;
    },
    handleNewChat() {
      // 获取MainContent组件的引用
      const mainContent = this.$refs.mainContent;
      if (mainContent && mainContent.$refs.chatInterface) {
        // 如果MainContent有ChatInterface引用，则调用其清空对话方法
        mainContent.$refs.chatInterface.clearInput();
      }
    },
    handleCottonClick() {
      // 触发棉花炭疽病信息展示
      this.$root.$emit('cottonClicked');
    }
  },
  mounted() {
    // 检查登录状态
    if (!checkAuth()) {
      // this.$router.push('/login');
      // return;
      console.log('用户未登录');
    }
    
    // 监听来自MainContent组件的棉花图片点击事件
    this.$root.$on('cottonImageClicked', this.handleCottonClick);
  },
  beforeDestroy() {
    this.$root.$off('cottonImageClicked', this.handleCottonClick);
  }
}
</script>

<style scoped>
.home-page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  background-color: #f5f5f5;
}

.sidebar-section {
  position: fixed;
  height: 100vh;
  z-index: 10;
  transition: width 0.3s;
  width: 318px;
}

.sidebar-hidden {
  width: 0;
}

.content-section {
  position: relative;
  height: 100vh;
  overflow-y: auto;
  background-color: #f9f9f9;
}

.content-full-width {
  margin-left: 0 !important;
  width: 100% !important;
}
</style>
